import { createSlice } from '@reduxjs/toolkit';
import { NOTIFICATIONS_SLICE_NAME } from '../slicesNames';
import * as notificationsConstants from './notificationsConstants';
import { CreateAction, NotificationState } from './notification.types';

const initialState: NotificationState = {
  isOpen: false,
  duration: null,
  message: null,
  severity: notificationsConstants.INFO,
  returnFocusKey: null,
  actionButton: null,
};

const notificationsSlice = createSlice({
  name: NOTIFICATIONS_SLICE_NAME,
  initialState,
  reducers: {
    create(state, action: CreateAction) {
      const {
        message,
        severity = notificationsConstants.INFO,
        duration = null,
        returnFocusKey = null,
        actionButton = null,
      } = action.payload;

      state.isOpen = true;
      state.message = message;
      state.duration = duration;
      state.returnFocusKey = returnFocusKey;
      state.actionButton = actionButton;
      if (notificationsConstants.VALID_SEVERITIES.includes(severity)) {
        state.severity = severity;
      }
    },
    hide(state) {
      state.isOpen = false;
    },
    pause(state) {
      state.duration = null;
    },
    clear() {
      return initialState;
    },
  },
});

export default notificationsSlice;
